var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { withRouter } from 'react-router';
import { WHITE_LIST } from '@/constants';
function wxHideAllNonBaseMenuItem() {
    // 白名单可以分享
    if (window.location.pathname.indexOf('lecture') !== -1 || window.location.pathname.indexOf('channel') !== -1) {
        console.log('白名单');
        return;
    }
    if (WHITE_LIST.indexOf(window.location.pathname) !== -1) {
        console.log('白名单');
        return;
    }
    window.Session.weixinApi && window.Session.weixinApi.initJSSDK();
    try {
        window.wx.ready(function () {
            var timer = setInterval(function () {
                window.wx.hideAllNonBaseMenuItem({
                    success: function () {
                        console.log('window.wx.hideAllNonBaseMenuItem success');
                        clearInterval(timer);
                    },
                    fail: function (err) {
                        console.log("window.wx.hideAllNonBaseMenuItem fail: " + err);
                    },
                });
            }, 200);
        });
    }
    catch (error) {
        console.log(error);
    }
}
var HistoryListener = /** @class */ (function (_super) {
    __extends(HistoryListener, _super);
    function HistoryListener() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HistoryListener.prototype.componentWillMount = function () {
        wxHideAllNonBaseMenuItem();
        this.props.history.listen(function () {
            wxHideAllNonBaseMenuItem();
        });
    };
    HistoryListener.prototype.render = function () {
        return this.props.children;
    };
    return HistoryListener;
}(React.Component));
export default withRouter(HistoryListener);



//////////////////
// WEBPACK FOOTER
// ./src/layout/history-listener/index.ts
// module id = 485
// module chunks = 41